import { createSelector } from 'reselect';

import { IProcedureEmail, IProceduresEmailsState } from 'types/proceduresEmails.types';

const getItems = (state: { proceduresEmails: IProceduresEmailsState }) =>
  state.proceduresEmails.items;

export const proceduresEmailsSelector = createSelector([getItems], (proceduresEmails) =>
  proceduresEmails.map((item: IProcedureEmail) => ({
    ...item,
    procedureName: item.procedure?.name,
  })),
);
